import React from 'react';
import style from '../../css/WhyCard_one.module.css';
import image1 from '../../assets/images/image_3.png';

import supportImage from '../../assets/images/image_4.png';

function WhyCard_one() {
	return (
		<div className={style.container}>
			<h2 className={style.title}>One website, endless travel options</h2>

			<div className={style.section}>
				<div className={style.card}>
					<div className={style.left}>
						<h3>Employee travel freedom</h3>
						<p>
							Give travelers access to an unrivaled business travel inventory —
							with corporate negotiated rates built in. Flights, hotels, trains,
							cars, and black cars are sourced from a network of corporate
							providers, direct connections, aggregators, and consumer sites.
						</p>
					</div>
					<div className={style.right}>
						<img src={image1} alt="Employee travel UI" />
					</div>
				</div>
			</div>

			<div className={style.section}>
				<div className={style.card}>
					<div className={style.left}>
						<img src={supportImage} alt="Support conversation UI" />
					</div>
					<div className={style.right}>
						<h3>Modern, consumer-grade experience</h3>
						<p>
							Empower your travelers to book and manage their trips quickly and
							confidently. Exporest was purpose-built to take the pain out of
							business travel and even surfaces personalized options based on
							booking history and loyalty affiliations.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default WhyCard_one;
